import React from "react"

import "./filter.scss"
import FilterMultiCheck from "../../atoms/filter-multi-check/filter-multi-check"
import FilterMultiCheckImg from "../../atoms/filter-multi-check-img/filter-multi-check-img"
import {handleName} from "../../../utils/changeNamesUtil"
const Filter = props => {
  const {
    segundoFiltro,
    tercerFiltro,
    cuartoFiltro,
    quintoFiltro,
    sextoFiltro,
    septimoFiltro,
    opcionesSegundoFiltro,
    opcionesTercerFiltro,
    opcionesCuartoFiltro,
    opcionesQuintoFiltro,
    opcionesSextoFiltro,
    opcionesSeptimoFiltro,
  } = props.filter
  const opcionExist = opcionExist => {
    if (opcionExist) {
      return opcionExist.length
    }
    return 0
  }

  const country = process.env.LOCALE
  return (
    <>
      <div className="f-Filter-active">
        {props.activeFilters.map((filter, index) => {
          if (filter.value) {
            return (
              <div key={index} className="f-Filter-active-items">
                <p>{handleName(filter.name, filter.nameFilter)}</p>
                <span
                  className="icon2-close"
                  onClick={() => {
                    if (index === 0) {
                      for (let i = 0; i < props.activeFilters.length; i++) {
                        props.activeFilters[i].value = false
                      }
                      props.setProductsFilter(props.products)
                      props.setActiveFilters([...props.activeFilters])
                    } else {
                      props.activeFilters.find(
                        x => x.id === filter.id
                      ).value = false
                      props.setActiveFilters([...props.activeFilters])
                      props.activeFilters[0].value = false
                      if (props.activeFilters.find(x => x.value === true)) {
                        props.activeFilters[0].value = true
                      } else {
                        props.activeFilters[0].value = false
                      }
                      props.filterFunction()
                    }
                  }}
                ></span>
              </div>
            )
          }
          return null
        })}
      </div>
      <div className="f-Filter">
        {/* Flujo */}
        {(segundoFiltro && (props.productTitle !== 'Protectores Diarios' )) && (
          <FilterMultiCheckImg
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={segundoFiltro}
            options={opcionesSegundoFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={1}
          />
        )}
       {/*  Ropa interior */}
        {tercerFiltro && (props.productTitle !== 'Toallas Higiénicas' || country !== 'es-AR') &&
          (props.productTitle !== 'Protectores Diarios' || country !== 'es-AR') &&(
          <FilterMultiCheck
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={tercerFiltro}
            options={opcionesTercerFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={opcionExist(opcionesSegundoFiltro) + 1}
          />
        )}
        {/* Tipo de piel */}
        {cuartoFiltro && (props.productTitle !== 'Toallas Higiénicas' || country !== 'es-AR') && 
         (props.productTitle !== 'Protectores Diarios' || country !== 'es-AR') &&
          (props.productTitle !== 'Tampones' || country !== 'es-AR') &&(
          <FilterMultiCheck
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={cuartoFiltro}
            options={opcionesCuartoFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={
              opcionExist(opcionesSegundoFiltro) +
              opcionExist(opcionesTercerFiltro) +
              1
            }
          />
        )}
        {/* Tipo de toalla */}
        {quintoFiltro && (props.productTitle !== 'Tampones' || country !== 'es-AR') && (process.env.LOCALE !== "es-CL") && (
          <FilterMultiCheck
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={quintoFiltro}
            titleProduct={props.productTitle}
            options={opcionesQuintoFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={
              opcionExist(opcionesSegundoFiltro) +
              opcionExist(opcionesTercerFiltro) +
              opcionExist(opcionesCuartoFiltro) +
              1
            }
          />
        )}
        {/* Tipo de actividad */}
        {(sextoFiltro && (props.productTitle !== 'Protectores Diarios' || process.env.LOCALE !== 'es-CO')) && (
          <FilterMultiCheck
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={sextoFiltro}
            options={opcionesSextoFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={
              opcionExist(opcionesSegundoFiltro) +
              opcionExist(opcionesTercerFiltro) +
              opcionExist(opcionesCuartoFiltro) +
              opcionExist(opcionesQuintoFiltro) +
              1
            }
          />
        )}
        {/* Caracteristica */}
        { septimoFiltro && (props.productTitle !== 'Toallas Higiénicas' || country !== 'es-AR') &&(process.env.LOCALE !== 'es-CO') && (
          <FilterMultiCheckImg
            currentSubcategory={props.currentSubcategory}
            activeFilters={props.activeFilters}
            title={septimoFiltro}
            options={opcionesSeptimoFiltro}
            handleChangeFilter={props.handleChangeFilter}
            numfilter={
              opcionExist(opcionesSegundoFiltro) +
              opcionExist(opcionesTercerFiltro) +
              opcionExist(opcionesCuartoFiltro) +
              opcionExist(opcionesQuintoFiltro) +
              opcionExist(opcionesSextoFiltro) +
              1
            }
          />
        )}
      </div>
    </>
  )
}

export default Filter
